<template>
    <el-dialog
        class="follow-form-dialog"
        :visible.sync="visible"
        :title="$t('Member.Follow.add')"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="100px"
            label-suffix=":">
            <el-form-item prop="name" :label="$t('Member.name2')">
                {{ form.name }}
            </el-form-item>
            <el-form-item prop="phone" :label="$t('Member.telephone')">
                {{ form.phone }}
            </el-form-item>
            <el-form-item :label="$t('Common.store')">
                <el-select
                    v-model="form.storeId"
                    :placeholder="$t('Common.store')"
                    class="w-full"
                    clearable>
                    <el-option
                        v-for="(item, index) in stores"
                        :key="index"
                        :label="item.name"
                        :value="item.id"/>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('Member.Follow.people')">
                <el-select
                    v-model="form.storeId"
                    :placeholder="$t('Common.please_choose')"
                    class="w-full"
                    clearable>
                    <el-option
                        v-for="(item, index) in stores"
                        :key="index"
                        :label="item.name"
                        :value="item.id"/>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('Member.Service.methods')" v-if="followType === 'full'">
                <el-radio-group v-model="form.serviceType">
                    <el-radio label="1" >{{ $t('Member.Service.phone') }}</el-radio>
                    <el-radio label="2" >{{ $t('Member.Service.sms') }}</el-radio>
                    <el-radio label="3" >{{ $t('Member.Service.face') }}</el-radio>
                    <el-radio label="4" >{{ $t('Member.Service.email') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Member.Service.status')">
                <el-select
                    v-model="form.storeId"
                    :placeholder="$t('Common.please_choose')"
                    class="w-full"
                    clearable>
                    <el-option
                        v-for="(item, index) in stores"
                        :key="index"
                        :label="item.name"
                        :value="item.id"/>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('Client.communication_result')">
                <el-radio-group v-model="form.result">
                    <el-radio label="1">{{ $t('Card.appoint_success') }}</el-radio>
                    <el-radio label="2">{{ $t('Member.Service.appoint_fail') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Member.Service.fail_reason')" v-if="form.result === '2'">
                <el-select
                    v-model="form.storeId"
                    :placeholder="$t('Common.please_choose')"
                    class="w-full"
                    clearable>
                    <el-option
                        v-for="(item, index) in stores"
                        :key="index"
                        :label="item.name"
                        :value="item.id"/>
                </el-select>
            </el-form-item>
            <template v-if="form.result === '1'">
                <template v-if="followType === 'coach'">
                    <el-form-item :label="$t('Reservationtype')">
                        <el-radio-group v-model="form.genderCode">
                            <el-radio label="1">{{ $t('Lesson.FreeCourseReserva') }}</el-radio>
                            <el-radio label="2">{{ $t('Lesson.PurchasedCourseReservat') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('Lesson.Appointmentcoach')" v-if="followType !== 'coach'">
                        <el-select
                            v-model="form.storeId"
                            :placeholder="$t('Common.please_choose')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in stores"
                                :key="index"
                                :label="item.name"
                                :value="item.id"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Appointment_class')">
                        <el-input
                            type="text"
                            style="width: 200px"
                            v-model="form.joinedClubBrand"/> {{ $t('Board.Team.festival') }}
                    </el-form-item>
                </template>
                <el-form-item :label="$t('Reservationtype')" v-if="followType === 'potential'">
                    <el-radio-group v-model="form.genderCode">
                        <el-radio label="1" >{{ $t('Card.Member_booking') }}</el-radio>
                        <el-radio label="2" >{{ $t('Card.LeagueBooking') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('Reception.Second.appoint_saler')" v-if="followType !== 'coach'">
                    <el-select
                        v-model="form.storeId"
                        :placeholder="$t('Common.please_choose')"
                        class="w-full"
                        clearable>
                        <el-option
                            v-for="(item, index) in stores"
                            :key="index"
                            :label="item.name"
                            :value="item.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Reception.Second.appoint_time')">
                    <el-date-picker
                        v-model="form.contactTime"
                        type="datetime"
                        :placeholder="$t('Week.Selectdate')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('Appointment_course')" v-if="followType !== 'full'">
                    <el-select
                        v-model="form.storeId"
                        :placeholder="$t('Common.please_choose')"
                        class="w-full"
                        clearable>
                        <el-option
                            v-for="(item, index) in stores"
                            :key="index"
                            :label="item.name"
                            :value="item.id"/>
                    </el-select>
                </el-form-item>
            </template>
            <el-form-item :label="$t('Lesson.Callcontent')">
                <el-input type="textarea" v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Lesson.Nextcontacttime')">
                <el-date-picker
                    v-model="form.nextTime"
                    type="datetime"
                   :placeholder="$t('Week.Selectdate')">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="submit" type="primary">{{ $t('Common.save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
} from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
    },
    data() {
        return {
            followType: '',
            stores: [],
            visible: false,
            form: {},
            rules: {
            },
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open(data, followType) {
            this.followType = followType;
            this.form = data;
            this.visible = true;
            this.fetchStore();
        },
        fetchStore() {
            API.get('store/list').then((res) => {
                this.stores = res;
            });
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.visible = false;
            });
        },
        postData() {
            this.$emit('input', 'update');
        },
    },
};
</script>

<style lang="scss">
.follow-form-dialog {
    .el-dialog {
        width: 430px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
}
</style>
